import { ElementDefinition } from '@amzn/exs-elements/web-component';
import schema from './config/settings-schema.json';

const tagName = 'amazon-purchase-button';

const definition: ElementDefinition = {
  tagName,
  schema,
  shadowMode: 'closed',
  version: 'v1.0',
};

// export default is required for definition.ts
export default definition;
